import React from "react";
import { motion } from "framer-motion";
import { ArrowLeft, Calendar, User, Tag } from "lucide-react";
import { Link } from "react-router-dom";

import heroImg from "../assets/article-cover-photo.png";
import articleImg from "../assets/slide1.jpg";

const Article = () => {
  return (
    <div className="bg-black text-white min-h-screen">

      {/* ================= HERO ================= */}
      <section
        className="relative min-h-[55vh] flex items-center justify-center overflow-hidden bg-cover bg-center"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/70"></div>

        {/* Decorative Elements */}
        <div className="absolute top-10 left-10 w-40 h-40 bg-lime-400/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-60 h-60 bg-lime-400/10 rounded-full blur-3xl"></div>

        <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-lime-400 uppercase tracking-[0.3em] text-sm font-semibold mb-5"
          >
            ARTICLE
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-4xl md:text-6xl font-bold leading-tight"
          >
            Understanding the Importance of
            <span className="text-lime-400"> Biodiversity Conservation</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="text-gray-300 text-lg mt-6 max-w-3xl mx-auto"
          >
            Exploring how science, communities and conservation efforts can
            work together to protect India's rich natural heritage.
          </motion.p>

        </div>
      </section>


      {/* ================= ARTICLE ================= */}
      

    </div>
  );
};

export default Article;